var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy } from '@angular/core';
import { FxAgGridValidationEditorComponent } from '../fx-ag-grid-validation-editor';
import { FormBuilder, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { FxDapHttpClient } from '../../fx-http-client';
var FxAgGridStatusCellRendererComponent = /** @class */ (function (_super) {
    __extends(FxAgGridStatusCellRendererComponent, _super);
    function FxAgGridStatusCellRendererComponent(fb, http) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.http = http;
        _this.label = '';
        _this.status = 'default';
        _this.color = 'transparent';
        return _this;
    }
    FxAgGridStatusCellRendererComponent.prototype.agInit = function (params) {
        var _this = this;
        this.values = params.values ? params.values : [];
        // console.debug('-------- fx-form-cell debugging');
        this.columnName = params.column.colDef.headerName;
        // this.key = params.context.createKey(params.columnApi, params.column);
        this.key = 'ag_' + params.node.id + '_' + params.colDef.field;
        this.value = params.getValue();
        if (Array.isArray(this.values)) {
            this.updateValue(this.values);
        }
        else {
            var observable = this.values;
            observable.subscribe(function (data) {
                _this.updateValue(data);
            });
        }
        this.formControl = new FormControl(this, params.validators);
        this.validateForm = params.form;
        if (!params.form) {
            this.validateForm = this.fb.group({});
        }
        this.validateForm.addControl(this.key, this.formControl);
        this.formControl.markAsDirty();
        _super.prototype.init.call(this);
    };
    FxAgGridStatusCellRendererComponent.prototype.updateValue = function (arr) {
        var _this = this;
        var matchedItem = arr.find(function (item) { return item.value === _this.value; });
        this.label = matchedItem.label;
        this.color = matchedItem.color || matchedItem.aaa004;
    };
    FxAgGridStatusCellRendererComponent.prototype.refresh = function (params) {
        var _this = this;
        // this.formGroup = params.context.formGroup.controls[this.rowId].get(this.key);
        //
        // // this could also be done in GridComponent.createFormControls, but the cell component could be doing something with
        // // the value, so it feels more natural that the control value be set here
        // // this.formGroup.at(this.key).patchValue(this.value);
        // this.formGroup.patchValue(this.value);
        this.value = params.value;
        if (Array.isArray(this.values)) {
            this.updateValue(this.values);
        }
        else {
            var observable = this.values;
            observable.subscribe(function (data) {
                _this.updateValue(data);
            });
        }
        return true;
    };
    FxAgGridStatusCellRendererComponent.prototype.debug = function () {
        console.debug('-------- fx-form-cell debugging');
        console.debug(this.formControl);
    };
    FxAgGridStatusCellRendererComponent.prototype.ngOnDestroy = function () {
        this.validateForm.removeControl(this.key);
    };
    return FxAgGridStatusCellRendererComponent;
}(FxAgGridValidationEditorComponent));
export { FxAgGridStatusCellRendererComponent };
